/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-tag.get-names.ts 
*/
.ace-tag {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: var(--ace-primitive-spacing-xx-tight);
  height: 2rem;
  justify-content: flex-start;
  max-width: fit-content;
  min-width: auto;
  overflow: hidden;
  padding: 0 var(--ace-primitive-spacing-x-tight);
  position: relative;
  width: 100%;
  z-index: 2;
}
.ace-tag * {
  box-sizing: border-box;
}
.ace-tag::before {
  background-color: var(--ace-tag-background-color);
  border: var(--ace-primitive-border-decorative);
  border-color: var(--ace-tag-border-color);
  border-radius: var(--ace-primitive-radius-x-small);
  bottom: 0;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}
.ace-tag--subtle::before {
  opacity: var(--ace-color-semantic-tag-subtle-background-opacity);
}
.ace-tag--game::before {
  border: unset;
}
.ace-tag--small {
  gap: 0.125rem;
  height: 1.5rem;
  padding: 0 var(--ace-primitive-spacing-xx-tight);
}
.ace-tag img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 0;
}
.ace-tag__slot {
  align-items: center;
  display: flex;
}
.ace-tag--game {
  gap: 0;
  padding: 0;
}
.ace-tag--game .ace-tag__slot {
  flex: 1;
  padding: 0 var(--ace-primitive-spacing-tight);
  width: calc(100% - 2.75rem);
}
.ace-tag--game .ace-tag__image {
  border-radius: var(--ace-primitive-radius-x-small) 0 0 var(--ace-primitive-radius-x-small);
  height: 100%;
  max-width: 2.75rem;
  overflow: hidden;
}
.ace-tag--game-only-img {
  height: unset;
  padding: 0;
}
.ace-tag--game-only-img .ace-tag__image {
  border-radius: var(--ace-primitive-radius-x-small);
  height: 2.5rem;
  overflow: hidden;
  width: 3.375rem;
}